<script setup>
import {computed} from "vue";

const siteUrl = document.querySelector('meta[name="site-url"]').content;

const props = defineProps({
  tag: {
    type: Object,
    required: true
  },
  categories: {
    type: Array,
    required: true
  }
});

/**
 * カテゴリー名を返す
 * @type {ComputedRef<unknown>}
 */
const categoryName = computed(() => {
  const category = props.categories.find(category => Number(category.id) === Number(props.tag.post_category_id));
  return category ? category.name : '';
});
</script>

<template>
  <li class="lyMt4 lyMr8 lyMb4">
    <a
      :href="siteUrl+'place/tag/'+tag.id"
      class="lyVerticalCnt lyPd8 pFont12 pFontBold pFontBlack pBackColorGray4 pBorderRadius2px"
    >
      {{categoryName}}
      <span class="lyMl2">#{{tag.name}}</span>
    </a>
  </li>
</template>
